import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToCTA = () => {
    const element = document.getElementById('cta-section');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-90">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-91">
        <img src="https://cdn.magicpatterns.com/uploads/rt32L3eP563XmYaWetS7bd/heylloyd-image-1770158091043.png" alt="Ocean scene with glowing anchor book" className="w-full h-full object-cover" data-id="element-92" />
        <div className="absolute inset-0 bg-[#0a1628]/80 mix-blend-multiply" data-id="element-93" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628]/50 via-transparent to-[#0a1628]" data-id="element-94" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center pt-20 pb-32" data-id="element-95">
        <FadeIn delay={0.2} data-id="element-96">
          <span className="inline-block py-1 px-3 border border-[#d4af37]/30 rounded-full bg-[#0a1628]/50 backdrop-blur-sm text-[#d4af37] text-sm tracking-widest uppercase mb-8" data-id="element-97">
            Hábitos Atómicos Espirituales
          </span>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-98">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-99">
            Si siempre empiezas y no terminas…{' '}
            <span className="text-[#d4af37] italic" data-id="element-100">esto es para ti.</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-101">
          <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-102">
            El sistema diario (con Dios) para dejar de empezar y por fin
            terminar.
          </p>
        </FadeIn>

        <FadeIn delay={0.8} data-id="element-103">
          <div className="flex flex-col md:flex-row gap-4 justify-center items-center" data-id="element-104">
            <Button onClick={scrollToCTA} className="min-w-[240px]" data-id="element-105">
              Consigue el Sistema Completo
            </Button>
          </div>
        </FadeIn>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      delay: 1.5,
      duration: 2,
      repeat: Infinity
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 text-white/50 cursor-pointer" onClick={scrollToCTA} data-id="element-106">
        <ChevronDown size={32} data-id="element-107" />
      </motion.div>
    </section>;
}